// Static message board on the driver dashboard's Notifications tab --
// admin-managed via Settings -> Driver Notices (src/components/settings/
// DriverNoticeBoardSettings.tsx). Deliberately separate from Comms Book:
// this is a small pinned-notice board (up to 3 shown at once), not a
// searchable/categorised message log with read receipts.
import { supabase } from "@/lib/supabase";

export const NOTICE_BOARD_DISPLAY_LIMIT = 3;

export interface NoticeBoardMessage {
  id: string;
  title: string | null;
  message: string;
  is_active: boolean;
  sort_order: number;
  created_at: string;
}

const FALLBACK_TITLE_LENGTH = 40;

/** The tile heading -- the admin-set title, or a truncated preview of the message if none was given. */
export function noticeBoardTitle(n: Pick<NoticeBoardMessage, "title" | "message">): string {
  if (n.title?.trim()) return n.title.trim();
  const flat = n.message.replace(/\s+/g, " ").trim();
  return flat.length > FALLBACK_TITLE_LENGTH ? `${flat.slice(0, FALLBACK_TITLE_LENGTH)}...` : flat;
}

/** Driver-facing: the top NOTICE_BOARD_DISPLAY_LIMIT active messages -- lowest sort_order first, newest breaking ties. */
export async function loadActiveNoticeBoardMessages(): Promise<NoticeBoardMessage[]> {
  const { data, error } = await supabase
    .from("driver_notice_board_messages")
    .select("id, title, message, is_active, sort_order, created_at")
    .eq("is_active", true)
    .order("sort_order", { ascending: true })
    .order("created_at", { ascending: false })
    .limit(NOTICE_BOARD_DISPLAY_LIMIT);
  if (error) {
    console.error("Error loading notice board messages:", error);
    return [];
  }
  return data || [];
}
